import type { ReactNode } from 'react';
import React, { useState } from 'react';

import NotifBadge from '@/core/components/NotifBadge';
import { useNativeContext } from '@/core/lib/native/native.context';

export interface Tab {
  name: string;
  onSelect?: (index: number) => void;
  content: ReactNode;
  showNotifBadge?: boolean;
  /** Remplace le NotifBadge par défaut à côté du nom de l'onglet */
  badge?: ReactNode;
}

export interface UpperTabProps {
  tabs: Tab[];
  defaultTab?: string | number; // index of tabs || Tab.name
}

const UpperTab: React.FC<UpperTabProps> = ({ tabs, defaultTab }) => {
  let indexDefaultTab: number = 0;
  const { isNative } = useNativeContext();

  if (typeof defaultTab === 'string') {
    indexDefaultTab = tabs.findIndex(t => t.name === defaultTab);
  }

  if (typeof defaultTab === 'number' && defaultTab <= tabs.length - 1 && defaultTab >= 0) {
    indexDefaultTab = defaultTab;
  }

  const [selectedIndex, setSelectedIndex] = useState<number>(indexDefaultTab);

  return (
    <div className="flex flex-col">
      <div className="sticky top-0 flex w-full gap-x-6 border-b border-stroke-secondary bg-bg-primary">
        {tabs.map((item, index) => {
          return (
            <button
              type="button"
              onClick={() => {
                setSelectedIndex(index);
                if (item?.onSelect) {
                  item.onSelect(index);
                }
              }}
              // -mb-px : le soulignement de l'onglet actif vient recouvrir la ligne de séparation de la barre
              className={`text-caption-primary -mb-px flex items-center border-b-2 px-1 py-3 font-semibold ${index === selectedIndex ? 'border-stroke-default-focus text-content-secondary' : 'border-transparent text-content-placeholder'}`}
              key={JSON.stringify(item.name)}
            >
              <span className="flex items-center gap-x-1">
                {item.name}
                {item.badge ?? <NotifBadge unread={0} size="large" isEmpty={item.showNotifBadge} />}
              </span>
            </button>
          );
        })}
      </div>
      <div className={isNative ? 'sm:pb-safe-bottom md:mb-14' : ''}>{tabs[selectedIndex].content}</div>
    </div>
  );
};

export default UpperTab;
